import React, { useCallback, useEffect, useState } from "react"

import styled from "@emotion/styled"
import { debounce } from "lodash"
import {
  Stack,
  TextField,
} from "@mui/material"
import { ErrorMessage, } from "formik"
import { StyledErrorMessage } from "../StyledSectionComponents"

const StyledTextField = styled(TextField)({
  width: 512,
  height: 30,
  background: "#fff",
  borderRadius: 4,
  "& .MuiInputBase-root": {
    "&:before, :after": {
      borderBottom: "none",
      "&:hover": {
        borderBottom: "none"
      }
    },
    "& .MuiInputBase-input": {
      paddingLeft: 7
    }
  },
  "& .MuiInput-input": {
    fontWeight: 600,
    fontSize: 14,
    color: "#414141"
  }
})


const SectionNameField = ({
  value,
  index,
  setFieldValue,
  onFieldFocus,
  onFieldBlur,
  onKeyUp,
}) => {
  const [localValue, setLocalValue] = useState("")

  // set the initial value of the section name
  useEffect(() => {
    if (!value) return
    setLocalValue(value)
  }, [])

  const handleClick = (event) => event.stopPropagation()

  // update the section name in the form level
  const handleDebouncedChange = debounce((value, sectionIndex) => {
    setFieldValue(`sections[${sectionIndex}].name`, value)
  }, 2000)

  // update the section name in the local field level
  const handleChange = useCallback((event) => {
    // to ensure that React will keep the event object as is even after the debounce
    event.persist()
    const value = event.target.value
    setLocalValue(value)
    handleDebouncedChange(value, index)
  }, [index])

  return (
    <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
      <StyledTextField
        // we use the local field value instead of the form level value
        value={localValue}
        onClick={handleClick}
        onFocus={onFieldFocus}
        onBlur={onFieldBlur}
        onKeyUp={onKeyUp}
        variant="standard"
        fullWidth
        onChange={handleChange}
      />
      <ErrorMessage
        name={`sections[${index}].name`}
        render={(message) => (
          <StyledErrorMessage>{message}</StyledErrorMessage>
        )}
      />
    </Stack>
  )
}

export default SectionNameField
